var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.506 14.358a6.09 6.09 0 0 1 .806-2.948 6.158 6.158 0 0 1 2.142-2.197 6.317 6.317 0 0 0-2.177-1.922 6.38 6.38 0 0 0-2.815-.752c-2.1-.219-4.136 1.245-5.206 1.245-1.091 0-2.739-1.223-4.513-1.187a6.692 6.692 0 0 0-3.247.96 6.614 6.614 0 0 0-2.347 2.42c-2.42 4.15-.615 10.248 1.702 13.602 1.16 1.642 2.514 3.477 4.287 3.412 1.734-.072 2.382-1.096 4.476-1.096 2.075 0 2.683 1.096 4.491 1.054 1.862-.03 3.035-1.65 4.153-3.307a13.535 13.535 0 0 0 1.9-3.833 5.968 5.968 0 0 1-2.654-2.18 5.887 5.887 0 0 1-.998-3.271ZM15.084 4.333A6.001 6.001 0 0 0 16.478.008a6.219 6.219 0 0 0-4.012 2.056 5.697 5.697 0 0 0-1.43 4.165 5.166 5.166 0 0 0 2.244-.486 5.12 5.12 0 0 0 1.804-1.41Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleicon);
export default __webpack_public_path__ + "static/media/appleicon.305170307f44d1cb3574137f07c749e9.svg";
export { ForwardRef as ReactComponent };